import React from "react";
import { ReactComponent as LogoSvg } from "../assets/svg/logo.svg";

const Logo = () => (
  // <LogoSvg className="h-auto w-18 md:w-24 lg:w-32 max-w-32 gradient-animation" />
  <LogoSvg className="h-auto min-w-10 w-[8vw] md:w-24 lg:w-28 max-w-32" id="logo"/>
);

export default Logo;